import { makeStyles } from '@material-ui/styles';
// import tinycolor from 'tinycolor2';

export default makeStyles(theme => ({

    st0: {
        fill: '#000082',
    },

    // st1: {
    //     fill: '#0078FF',
    // },

    st2: {
        fill: '#FFFFFF',
    },

    st3: {
    },

    st4: {
        fontSize: '16px',
        fontWeight: '500',
    },

    st5: {
        fill: '#010134',
    },

    st6: {
        clipPath: 'url(#SVGID_3_)',
    },

}));
